import { createAction } from 'redux-actions';

export const requestSaveSearchInstanceAction = createAction('REQUEST/SAVE_SEARCH_INSTANCE');

export const toggleSearchMapDrawingModeAction = createAction('SEARCH/TOGGLE_MAP_DRAWING_MODE');
export const cleanSearchDrawnPolygonAction = createAction('SEARCH/CLEAN_DRAWN_POLYGON');
export const setSearchDrawnPolygonAction = createAction('SEARCH/SET_DRAWN_POLYGON');
